/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentCreate = {
    properties: {
        dateFrom: {
            type: 'string',
            isRequired: true,
            format: 'date',
        },
        dateTo: {
            type: 'string',
            isRequired: true,
            format: 'date',
        },
        sports: {
            type: 'SportEnum',
            isRequired: true,
        },
        cup: {
            type: 'boolean',
            isRequired: true,
        },
        name: {
            type: 'string',
            isRequired: true,
        },
        areaOfInterestIds: {
            type: 'array',
            contains: {
                type: 'number',
            },
            isRequired: true,
        },
    },
} as const;
